import validate from "/home/runner/work/ss-bonsai-admin-frontend/ss-bonsai-admin-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/runner/work/ss-bonsai-admin-frontend/ss-bonsai-admin-frontend/middleware/auth.global.ts";
import me_45global from "/home/runner/work/ss-bonsai-admin-frontend/ss-bonsai-admin-frontend/middleware/me.global.ts";
import manifest_45route_45rule from "/home/runner/work/ss-bonsai-admin-frontend/ss-bonsai-admin-frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  me_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}